// Render the member center
import React, { useState, useEffect, useRef } from "react";
import useApi from "../../hooks/UseApi";

document.title = "Member Center - Long Now";

const MemberCenter = (props) => {
  const { get, put } = useApi();
  const [notifications, setNotifications] = useState([]);
  const toastRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (props.message) {
      showSuccess(props.message);
      window.history.pushState("", "", "/members");
    }
    get(
      `membership/user/${props.member.username}/preferences/notifications`
    ).then((data) => {
      setNotifications(data);
    });
  }, []);

  const isMounted = useRef(false);
  useEffect(() => {
    if (isMounted.current) {
      put(
        `membership/user/${props.member.username}/preferences/notifications`,
        notifications,
        "csrf"
      ).then((data) => {});
    } else {
      isMounted.current = true;
    }
  }, [notifications]);

  const showSuccess = (message) => {
    toastRef.current.classList.remove("flash");
    toastRef.current.offsetHeight;
    toastRef.current.classList.add("flash");
    toastRef.current.classList.add("toast-success");
    setToastMessage(message);
  };

  const Newsletters = () => {
    const [newsletters, setNewsletters] = useState([]);
    useEffect(() => {
      get(`newsletters`).then((data) => {
        if (data) {
          setNewsletters(data.results);
        }
      });
    }, []);

    const listNewsletters = newsletters.map((newsletter, index) => (
      <a
        href={`https://www.longnow.org/${newsletter.url}`}
        key={index}
        className="component-newsletter"
      >
        <div
          className="component-newsletter-image"
          style={{ backgroundImage: `url(${newsletter.thumbnail_url})` }}
        ></div>
        <div className="newsletter-details">
          <h6>In this issue —</h6>
          <p>{newsletter.teaser.slice(15)}</p>
        </div>
      </a>
    ));
    return <div className="component-newsletters">{listNewsletters}</div>;
  };

  return (
    <div className="component-member-center">
      <div className="with-sidebar">
        <div className="with-sidebar-main left">
          <h3>Member newsletters</h3>
          <Newsletters />
        </div>
        <div className="member-sidebar with-sidebar-side">
          <h4>More ways to engage</h4>
          <ul>
            <li>
              <a href="/talks">Get member tickets to Long Now Talks</a>
            </li>
            <li>
              <a href="/talks#podcasts">Subscribe to the Long Now podcast</a>
            </li>
            <li>
              <a href="/ideas">Explore Long Now Ideas</a>
            </li>
            <li>
              <a href="http://www.google.com/calendar/ical/longnow.seminars%40gmail.com/public/basic.ics">
                Subscribe to the Long Now calendar
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
export default MemberCenter;
